<template>
  <div class="page page-catalogues">
    <div class="page__wrap" data-animate="page-wrap">
      <div class="row-1 p-top-3 p-bot-3">
        <header>
          <h1 data-animate="header-title" class="title-m">
            {{ catalogues.title }}
          </h1>
        </header>
      </div>
      <!-- List -->
      <PagesCataloguesList class="row-1 p-bot-3" :catalogues="list" />
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { configuration } = useCraftStore()

const limit = ref(10)

// Fetch Data
const query = queries.catalogues.getCatalogues

const variables = computed(() => ({
  site: configuration.site,
  limit: limit.value,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.cataloguesEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const catalogues = computed(() => data.value?.cataloguesEntries?.[0])
const list = computed(
  () => data.value?.cataloguesEntries?.[0]?.catalogues || []
)
const seo = computed(() => data.value?.cataloguesEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
